import { render } from "./onBoardLayout.vue?vue&type=template&id=ce2e9676&scoped=true&ts=true"
import script from "./onBoardLayout.vue?vue&type=script&lang=ts"
export * from "./onBoardLayout.vue?vue&type=script&lang=ts"

import "./onBoardLayout.vue?vue&type=style&index=0&id=ce2e9676&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ce2e9676"]])

export default __exports__